module.exports = __webpack_public_path__ + "static/media/landb-voucher.c38e3772.png";